module.exports = __webpack_public_path__ + "static/media/Gene_X_Normal_Length_Control_DNA.52883a6b.svg";